module.exports = __webpack_public_path__ + "img/no_issue_data.100525f8.png";